import React, { ReactNode } from "react";
import AuthLoading from "@/common/components/AuthLoading/auth-loading";
import { SessionProvider } from "@/common/providers/session-provider";

interface AuthenticatedShellProps {
  children: ReactNode;
  /** Shown while Midway authentication resolves. */
  loadingSkeleton: ReactNode;
}

/**
 * Resolves Midway authentication and exposes the session. It grants no access on its own;
 * each route decides who may see it with a {@link PermissionGate}.
 */
export const AuthenticatedShell: React.FC<AuthenticatedShellProps> = ({
  children,
  loadingSkeleton,
}) => (
  <AuthLoading loadingSkeleton={loadingSkeleton}>
    <SessionProvider>{children}</SessionProvider>
  </AuthLoading>
);
